import { useQuery } from '@tanstack/react-query';

export const useTableauViz = () => {
  const { data: isLoaded, isLoading, error } = useQuery({
    queryKey: ['tableau-script'],
    queryFn: async () => {
        if (window.tableau) {
            return true;
        }
        
        await import('https://public.tableau.com/javascripts/api/tableau.embedding.3.latest.min.js');
        return true;
    },
    staleTime: Infinity,
    cacheTime: Infinity,
  });

  return {
    isLoaded: !!isLoaded,
    isLoading,
    error
  };
};
